export var RankEffectiveBetRecordType;
(function (RankEffectiveBetRecordType) {
    RankEffectiveBetRecordType["DEDUCT"] = "deduct";
    RankEffectiveBetRecordType["REVOKE"] = "revoke";
})(RankEffectiveBetRecordType || (RankEffectiveBetRecordType = {}));
//# sourceMappingURL=RankEffectiveBetRecordType.js.map